import { TextField } from '@material-ui/core'
import { useEffect } from 'react'
import { useTranslate } from 'react-admin'

const TimePickerInput = ({
  record,
  label,
  required,
  source,
  setPayload,
  payload,
  setErrors,
  errors,
  ...props
}) => {
  const translate = useTranslate()
  useEffect(() => {
    setPayload(() => {
      return { ...payload, [source]: record[source] }
    })
  }, [])
  return (
    <TextField
      required={required}
      error={required && errors.includes(source)}
      id="datetime-local"
      label={translate(label, { _: label })}
      type="time"
      value={payload[source]}
      style={{ width: '100%' }}
      InputLabelProps={{
        shrink: true,
        required: true,
      }}
      onChange={(e) => {
        if (required && !e.target.value) {
          setErrors(() => {
            return errors.map((err) => {
              return err.id == props.id
                ? {
                    id: props.id,
                    source: source,
                    type: 'time',
                    label: label,
                  }
                : err
            })
          })
        } else {
          setErrors(() => {
            return errors.filter((item) => item.id !== props.id)
          })
        }
        setPayload({ ...payload, [source]: e.target.value })
      }}
    />
  )
}
export default TimePickerInput
